import React from 'react'

import { CSSHandler } from 'utils'


const ListSubBtn = ({
	btnID,
	subItem,
	account,
	itemDidTapped,
	itemWillShow,
  	searchValue,
	isSmallScreen,
	itemType,
	onClick,
	// onModalToggle
}) => {
	const { answer_title, label, explanation, Style } = subItem;
	// const isQADefault = itemDidTapped.isDefault;
	
	if (Style === 'Display') { return null; }

	let isSubActive = true;
	// let explanationComponent = null;

	if (itemWillShow) {
		isSubActive = account === itemWillShow.account
				&& label === itemWillShow.sub_account;
	}

	if (itemDidTapped) {
		isSubActive = account === itemDidTapped.account
				&& label === itemDidTapped.sub_account;
	}

	isSubActive = (isSubActive && !isSmallScreen) ? 'active' : '';

	// if (explanation) {
	// 	explanationComponent = (
	// 		<i
	// 			className='cursor-pointer elegant elegant-eleganticons-190'
	// 			onClick={onModalToggle}
	// 		/>
	// 	);
	// }

	return (
		<div
			className={`content-btn ${btnID} ${isSubActive}`}
			data-account={account}
			data-subaccount={label}
			data-type={itemType}
			onClick={(!isSubActive || isSmallScreen) ? onClick : () => {}}
		>
			{CSSHandler.highlightKeywords(answer_title ?? label, searchValue)}

			{explanation ? ' - ' : null}

			{explanation ? CSSHandler.highlightKeywords(explanation, searchValue) : null}
		</div>
	);
};


export { ListSubBtn }
